module.exports = __webpack_public_path__ + "img/6.aaa1ce68.png";